<template>
  <div class="ui-horizontal-table">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'UIHorizontalTable',
};
</script>

<style lang="scss" scoped>
@import '@src/design/ui-design/_variables.scss';

.ui-horizontal-table {
  @include horizontal-table-base(100%, 400px);
  scrollbar-width: thin;
  scrollbar-color: $gray-300 transparent;

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: $gray-300;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: $gray-400;
  }
}
</style>